function initTrustmarksMarquee() {
  if (!window.ResillionTrustmarkMarquee) return;

  document
    .querySelectorAll(".trustmarks [data-trustmarks-marquee]")
    .forEach((marquee) => {
      window.ResillionTrustmarkMarquee.init(marquee, { scale: true });
    });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTrustmarksMarquee, {
    once: true,
  });
} else {
  initTrustmarksMarquee();
}
